import React from 'react'
import Foundation from "../../img/fondation.jpg";
import Ecokaz from "../../img/ecokaz.webp";
import Envirennement from "../../img/envirennement.jpg";
import Dechets from "../../img/dechets.jpg";

function Propos() {
  return (
    <div className="bg-gradient-to-t from-pink-100 via-pink-50 to-pink-100">
      <div className="px-5 md:px-12 lg:px-32 xl:px-40 2xl:px-60 py-8 md:py-12 lg:py-20">
        <h2 className="text-xl sm:text-2xl md:text-3xl lg:text-4xl poppins-bold uppercase text-center bg-pink-600 py-2 md:py-4 text-white">
          À propos
        </h2>
        <p className="sm:px-4 lg:px-8 xl:px-14 2xl:px-16 py-4 xl:py-8 text-sm sm:text-base text-justify poppins-semibold text-gray-700">
          ECOKAZ se spécialise dans la collecte, le traitement et la
          transformation des déchets plastiques en pavés, tuiles, chaises,
          carreaux et portes à rideaux. Avec des opérations à Maurice et à
          Madagascar, ECOKAZ emploie actuellement dix personnes et possède sa
          propre usine de recyclage. ECOKAZ vise à transformer les déchets
          plastiques en ressources valorisables tout en respectant
          l'inclusivité et la diversité. Qui mieux qu'ECOKAZ pour l'écologie à
          la maison? ECOKAZ est une initiative des jeunes pour contribuer aux
          développement durable en Afrique.
        </p>

        <div className="grid md:grid-cols-2 gap-5 mt-8 items-center">
          <div className="md:text-end px-0 sm:px-4 md:px-0">
            <h2 className="text-2xl lg:text-3xl poppins-bold uppercase">
              Bijou Fifaliana, fondateur
            </h2>
            <p className="mt-3 lg:mt-6 text-sm sm:text-base text-gray-500 poppins-italic">
              Je m'appelle Monsieur IRINOMENA Bijou Fifaliana, âgé de 26 ans,
              Entrepreneur/Ingenieur en Génie Civil et Aménagement/Enérgie
              durable et Management envirennemental; Lauréat du concours MIME
              2024 AUF Maurice "Soutenir notre projet c'est soutenir la
              jeunesse en Afrique"
            </p>
          </div>
          <div className='sm:px-16 md:p-0 pt-6 md:pt-0'>
            <img src={Foundation} className="rounded-lg" alt="Olatov" />
          </div>
        </div>
        <div className="grid md:grid-cols-3 gap-5 mt-5 md:mt-10">
          <div className="relative w-full flex items-center justify-center">
            <div
              className="absolute inset-0 bg-cover bg-center rounded-xl"
              style={{ backgroundImage: `url(${Ecokaz})` }}
            ></div>
            <div className="relative bg-black bg-opacity-30 w-full h-48 rounded-xl text-center flex items-center justify-center">
              <p className="text-sm text-white poppins-bold">
                "Qui mieux qu'ECOKAZ l'écologie dans la KAZ"
              </p>
            </div>
          </div>
          <div className="relative w-full flex items-center justify-center">
            <div
              className="absolute inset-0 bg-cover bg-center rounded-xl"
              style={{ backgroundImage: `url(${Envirennement})` }}
            ></div>
            <div className="relative bg-black bg-opacity-30 w-full text-center flex items-center justify-center h-48 rounded-xl">
              <div>
                <h5 className="text-sm text-white poppins-bold">
                  "Respect de l'envirennement" <br></br>
                </h5>
                <p className="text-white text-sm mt-2">
                  Pour une brique vous évitez de jeter 0.8 Kg de plastique dans
                  la nature
                </p>
              </div>
            </div>
          </div>
          <div className="relative w-full flex items-center justify-center rounded">
            <div
              className="absolute inset-0 bg-cover bg-center rounded-xl"
              style={{ backgroundImage: `url(${Dechets})` }}
            ></div>
            <div className="relative bg-black bg-opacity-30 w-full text-center flex items-center justify-center h-48 rounded-xl">
              <div>
                <h5 className="text-sm text-white poppins-bold">
                  "Inclusion sociale" <br></br>
                </h5>
                <p className="text-white text-sm mt-2">
                  Valorisation des ressources humaines locaux pour un
                  dévéloppement approprié
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  )
}

export default Propos